// @flow

import composeActionCreators from './composeActionCreators'
import composeActionTypes from './composeActionTypes'
import composeReducers from './composeReducers'
import { createOperation } from './utils'

import type {
  Operator,
} from '../types'

type Args = {
  model: string,
  disableReducers?: boolean,
  branch?: string,
}

export default function composeOperator<T: Object> ({
  model: modelName,
  disableReducers = false,
  branch = 'operations',
  }: Args): Operator<T> {
  return {
    actionTypes: composeActionTypes({ model: modelName.toUpperCase() }),
    actionCreators: composeActionCreators({ model: modelName.toUpperCase() }),
    reducers: disableReducers ? null : composeReducers({
      model: modelName.toUpperCase(),
      branch,
      createOperation,
    }),
    create: createOperation,
  }
}
